import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import * as React from "react";
import { useStaticQuery } from "gatsby";
import Popup from "reactjs-popup";
import { svgToDataUri } from "../../appTheme";
import styled from "../../styled-components";
import { getUserClaims, getIdPJwt, logout } from "../../ui/auth/utils";
import { useIdpLoginPath } from "../RedirectToLogin";
import { UniversalLink } from "../UniversalLink/UniversalLink";
import { NavIcon, NavItem, navItemStyles } from "./navbar.elements";
export function LoginMenu(_ref) {
  var _e$userLabel, _e$userLabel2, _e$userAvatar, _e$userAvatar2;

  var a = _ref.mobile;

  var b = getUserClaims(),
      c = getIdPJwt(),
      d = useIdpLoginPath(void 0),
      _useStaticQuery = useStaticQuery("1398840060"),
      e = _useStaticQuery.siteConfig.login,
      _React$useState = React.useState(!1),
      f = _React$useState[0],
      g = _React$useState[1],
      h = React.useCallback(function () {
    return g(!0);
  }, []),
      i = React.useCallback(function () {
    return g(!1);
  }, []);

  if (!e) return null;
  var j = null === e.userLabel ? null : (b === null || b === void 0 ? void 0 : b[((_e$userLabel = e.userLabel) === null || _e$userLabel === void 0 ? void 0 : _e$userLabel.claim) || "email"]) || ((_e$userLabel2 = e.userLabel) === null || _e$userLabel2 === void 0 ? void 0 : _e$userLabel2.fallback) || "Unknown user",
      k = b === null || b === void 0 ? void 0 : b[(_e$userAvatar = e.userAvatar) === null || _e$userAvatar === void 0 ? void 0 : _e$userAvatar.claim],
      l = b === null || b === void 0 ? void 0 : b[(_e$userAvatar2 = e.userAvatar) === null || _e$userAvatar2 === void 0 ? void 0 : _e$userAvatar2.fallbackLettersClaim];
  return b && c ? /*#__PURE__*/React.createElement(Popup, {
    trigger: /*#__PURE__*/React.createElement(LoginWrap, {
      "aria-label": "Open popup menu"
    }, /*#__PURE__*/React.createElement(UserAvatar, {
      picture: k,
      name: l
    }), /*#__PURE__*/React.createElement(UserLabel, null, j, /*#__PURE__*/React.createElement(ArrowIcon, null))),
    open: f,
    onOpen: h,
    onClose: i,
    position: a ? "bottom center" : "bottom right",
    offsetY: 10,
    on: "click",
    closeOnDocumentClick: !0,
    arrow: !1
  }, /*#__PURE__*/React.createElement(PopupMenu, {
    onClick: i
  }, e.menu.map(function (a, b) {
    switch (a.type) {
      case "logout":
        return /*#__PURE__*/React.createElement("li", {
          key: b
        }, a.icon ? /*#__PURE__*/React.createElement(NavIcon, {
          url: a.icon
        }) : null, /*#__PURE__*/React.createElement("button", {
          onClick: function onClick() {
            return logout(a.link);
          }
        }, "Sign out"));

      case "page":
      case "href":
        return /*#__PURE__*/React.createElement("li", {
          key: b
        }, a.icon ? /*#__PURE__*/React.createElement(NavIcon, {
          url: a.icon
        }) : null, /*#__PURE__*/React.createElement(UniversalLink, {
          to: a.link
        }, a.label));

      case "separatorLine":
        return /*#__PURE__*/React.createElement(SeparatorLine, {
          key: b
        });
    }

    return null;
  }))) : /*#__PURE__*/React.createElement(NavItem, null, /*#__PURE__*/React.createElement("a", {
    href: d
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, e.label || "Sign in"))));
}

function UserAvatar(a) {
  var b = a.picture,
      c = a.name;
  if (b) return /*#__PURE__*/React.createElement(StyledUserAvatar, {
    image: b
  });

  if (c) {
    var _a = c.split(" "),
        _b = 1 < _a.length ? _a[0].slice(0, 1) + _a[1].slice(0, 1) : c.slice(0, 2);

    return /*#__PURE__*/React.createElement(StyledUserAvatar, null, _b);
  }

  return null;
}

var arrowIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"#000\" viewBox=\"0 0 451.847 451.847\" width=\"12px\" height=\"12px\" ><path d=\"M225.923 354.706c-8.098 0-16.195-3.092-22.369-9.263L9.27 151.157c-12.359-12.359-12.359-32.397 0-44.751 12.354-12.354 32.388-12.354 44.748 0l171.905 171.915 171.906-171.909c12.359-12.354 32.391-12.354 44.744 0 12.365 12.354 12.365 32.392 0 44.751L248.292 345.449c-6.177 6.172-14.274 9.257-22.369 9.257z\" /></svg>";
export var ArrowIcon = styled.i(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  background-repeat: no-repeat;\n  background-size: 12px 12px;\n  margin-left: 6px;\n  vertical-align: middle;\n  background-image: url('", "');\n"])), function (_ref2) {
  var a = _ref2.theme;
  return svgToDataUri(arrowIcon, a.colors.navbar.contrastText);
});
export var PopupMenu = styled.ul(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  background-color: #fff;\n  border-radius: ", ";\n  box-shadow: 0px 10px 30px 0px rgba(35, 35, 35, 0.1);\n  min-width: 200px;\n  padding: 0;\n  padding-top: 0.25em;\n  padding-bottom: 0.25em;\n  margin: 0;\n  li {\n    font-size: ", ";\n    list-style: none;\n    padding: 5px 10px;\n    transition: background-color 0.25s ease;\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.1);\n      a,\n      button {\n        color: ", ";\n      }\n    }\n  }\n  a,\n  button {\n    display: inline-block;\n    color: ", ";\n    padding: 0.5em 1em;\n    transition: color 0.25s ease;\n    cursor: pointer;\n    text-decoration: none;\n    width: 100%;\n    text-align: left;\n  }\n  button {\n    background-color: transparent;\n    outline: 0;\n    border: 0;\n  }\n"])), function (a) {
  return a.theme.shape.borderRadius;
}, function (a) {
  return a.theme.navbar.fontSize;
}, function (_ref3) {
  var a = _ref3.theme;
  return a.colors.primary.main;
}, function (_ref4) {
  var a = _ref4.theme;
  return a.colors.text.primary;
});
var LoginWrap = styled.li(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  ", "\n  display: inline-block;\n  line-height: calc(", " * (0.625 * 2 + 1));\n  cursor: pointer;\n  vertical-align: middle;\n\n  padding-left: 1.5em;\n\n  @media only screen and (max-width: ", ") {\n    padding: 5px 0;\n  }\n\n  > span {\n    vertical-align: middle;\n  }\n"])), navItemStyles, function (_ref5) {
  var a = _ref5.theme;
  return a.navbar.fontSize;
}, function (_ref6) {
  var a = _ref6.theme;
  return a.breakpoints.medium;
}),
    StyledUserAvatar = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  background: rgb(80, 90, 111);\n  text-align: center;\n  vertical-align: middle;\n\n  font-weight: 500;\n  text-transform: uppercase;\n  cursor: pointer;\n  user-select: none;\n\n  ", "\n"])), function (_ref7) {
  var a = _ref7.theme,
      b = _ref7.image;
  return "\n    width: calc(" + a.navbar.fontSize + " * (0.625 * 2 + 1));\n    height: calc(" + a.navbar.fontSize + " * (0.625 * 2 + 1));\n    line-height: calc(" + a.navbar.fontSize + " * (0.625 * 2 + 1));\n\n    border-radius:  " + a.components.login.avatarBorderRadius + ";\n    background: " + a.components.login.avatarBgColor + ";\n\n    background-image: url(" + b + ");\n    background-size: cover;\n  ";
}),
    UserLabel = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  vertical-align: middle;\n  margin-left: 5px;\n"]))),
    SeparatorLine = styled.li(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  display: block;\n  width: 100%;\n  height: 1px;\n  padding: 0 !important;\n  margin: 0;\n  background-color: ", ";\n"])), function (_ref8) {
  var a = _ref8.theme;
  return a.sidebar.separatorLineColor;
});